










































import { Vue, Prop, Component } from "vue-property-decorator"

@Component({})
export default class CreateRecipeBasicInfo extends Vue {
	@Prop({ required: true }) recipe!: RecipeObject;
}
